import CustomTable from "./CustomTable";

export const PrimaryBTN = ({
  children,
  isDisabled,
  isLoading,
  handleClick,
  bg,
  border,
  color,
  ...props
}) => {
  return (
    <CustomTable.BrandButton
      w="100%"
      isLoading={isLoading}
      onClick={handleClick}
      isDisabled={isDisabled}
      {...props}
    >
      {children}
    </CustomTable.BrandButton>
  );
};
